export default "__VITE_ASSET__$TGoT1J2__"